import React, { FormEvent, useEffect, useState } from "react";
import {
    Paper,
    Card,
    Stack,
    MenuItem,
    InputLabel,
    FormControl,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import MaterialTable, { Column } from "@material-table/core";
import { Link } from "react-router-dom";
import { Upload, Storage, ExpandMore } from "@mui/icons-material";

import { Footer, Backdrop } from "../../../components/shared";
import { MatterService } from "../../../services/ClientService";
import * as APIModels from "../../../models";
import { Globals } from "../../../helpers/globals";
import DatabaseCard from "../DatabaseCard";
import AppBar from "../AppBar";

function toCamelCase(str: string): string {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, "");
}

type DynamicDict = { [key: string]: string };
type OrderedDynamicDict = { [key: number]: DynamicDict };
type NameValueOptionType = { label: string; value: string };

const ImportPage = () => {
    const [csvHeader, setHeaders] = useState<Array<Column<DynamicDict>>>();
    const [csvData, setCsvData] = useState<Array<DynamicDict>>();
    const [importData, setImportData] = useState<Array<OrderedDynamicDict>>();
    const [identifier, setIdentifier] = useState<string>();
    const [file, setFile] = useState<File>();
    const [expand, setExpanded] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [importing, setImporting] = useState<boolean>(false);
    const [statuses, setStatuses] = useState<
        Array<APIModels.MatterLogResponse>
    >([]);
    const [identifierOptions, setIdentifierOptions] = useState<
        Array<NameValueOptionType>
    >([]);
    const [selectedIdentifierOption, setSelectedIdentifierOption] =
        useState<NameValueOptionType>();
    const fileReader = new FileReader();

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e) {
            if (e.target.files === null) throw new Error();
            setFile(e.target?.files[0]);
        }
    };

    const csvFileToArray = (csvString: string) => {
        let headers = csvString.slice(0, csvString.indexOf("\n")).split(",");
        const csvRows = csvString
            .slice(csvString.indexOf("\n") + 1)
            .split("\n");
        csvRows.pop();
        headers = headers.map(toCamelCase);
        setHeaders(
            headers.map<Column<DynamicDict>>((i: string) => {
                return {
                    title: i
                        .split(" ")
                        .map((k) => k.toUpperCase())
                        .join(""),
                    field: toCamelCase(i),
                    editable: "never",
                };
            })
        );
        const options = headers.map<NameValueOptionType>((i: string) => {
            return {
                label: toCamelCase(i),
                value: toCamelCase(i),
            } as NameValueOptionType;
        });
        setIdentifierOptions(options);

        const csv = [] as Array<DynamicDict>;
        const importDataObject = [] as Array<OrderedDynamicDict>;
        // iterate for each Array<importObject>
        csvRows.forEach((row) => {
            // get the importObject[i]
            const values = row.split(",");
            // use this to add in to material ui
            const csv_row = {} as DynamicDict;
            // use this to import with orderd preserve
            const importData_row = {} as OrderedDynamicDict;

            // header: mergefieldKey, index: mergefieldKey_index <- index to get appropriate mergefieldName
            headers.forEach((header, index) => {
                csv_row[header] = values[index];
                importData_row[index] = { [header]: values[index] };
                // set the identifier ... key-checked -> 0
                // set mergefield     ... key-checked <- 0
                // and if the         ... key-checked == 0
                if (identifier === header && index !== 0) {
                    const temp = importData_row[0];
                    importData_row[0] = { [header]: values[index] };
                    importData_row[index] = temp;
                }
            });

            csv.push(csv_row);
            importDataObject.push(importData_row);
        });
        setCsvData(csv);
        setImportData(importDataObject);
    };

    const handleSubmit = () => {
        if (file) {
            fileReader.onload = function (event) {
                if (event === null) {
                    throw new Error();
                } else {
                    const text = event?.target?.result?.toString() ?? "";
                    csvFileToArray(text);
                }
            };
            fileReader.readAsText(file);
        }
    };

    useEffect(() => {
        handleSubmit();
    }, [file]);

    const identifierSelectionHandler = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setIdentifier((event.target as HTMLInputElement).value);
        setShow(false);
    };

    useEffect(() => {
        if (identifier) {
            console.log({ identifier: identifier });
            importData?.forEach((importData_row) => {
                for (
                    let index = 0;
                    index < Object.keys(importData_row).length;
                    index++
                ) {
                    console.log({
                        [Object.keys(importData_row[index])[0]]:
                            Object.keys(importData_row[index])[0] ===
                            identifier,
                    });
                    if (
                        index !== 0 &&
                        Object.keys(importData_row[index])[0] === identifier
                    ) {
                        const mergefield0 = importData_row[0];
                        const mergefield0Key = Object.keys(mergefield0)[0];
                        const mergefield0Field = Object.values(mergefield0)[0];
                        const mergefieldIdentifier = importData_row[index];
                        const mergefieldIdentifierKey =
                            Object.keys(mergefieldIdentifier)[0];
                        const mergefieldIdentifierField =
                            Object.values(mergefieldIdentifier)[0];
                        importData_row[0] = {
                            [mergefieldIdentifierKey]:
                                mergefieldIdentifierField,
                        };
                        importData_row[index] = {
                            [mergefield0Key]: mergefield0Field,
                        };
                        console.log({
                            importData_row0: {
                                [mergefieldIdentifierKey]:
                                    mergefieldIdentifierField,
                            },
                            importData_rowIdentifier: {
                                [mergefield0Key]: mergefield0Field,
                            },
                        });
                    }
                }
            });
        }
        console.log({ ...importData });
    }, [identifier]);

    const importingHandler = async () => {
        const response = await MatterService.bulk({
            organizationId:
                Globals.currentUserValue.organizationID ?? APIModels.EmptyGuid,
            body: {
                identifier: identifier,
                dynamicDictEntry: importData,
            } as APIModels.ImportMattersRequest,
        });

        if (response.data) {
            setStatuses(response.data);
        } else {
            throw new Error("Wow ");
        }
    };

    useEffect(() => {
        importing &&
            importingHandler().then(() => {
                setImporting(false);
            });
    }, [importing]);

    return (
        <div className="content">
            <div className="container-fluid">
                <Backdrop
                    open={importing}
                    title="Please wait while your matters are imported."
                />
                <Dialog
                    open={show}
                    onClose={() => {
                        setShow(false);
                    }}
                >
                    <DialogTitle>
                        Choose a Matter Identifier Column For This Import
                    </DialogTitle>
                    <DialogContent>
                        <Stack
                            direction={"column"}
                            spacing={8}
                            justifyContent="start"
                        >
                            <p>
                                Choosing a Column from your imported csv headers
                                will allow you to see the data associated with
                                the column in eMatterMagic's{" "}
                                <b>Matter Managment</b> table. You can change
                                the identifier later for a matter. You just have
                                to click the matter number in the{" "}
                                <b>Matter Managment</b>. Be sure to choose one
                                your you well not continue.{" "}
                            </p>
                            <br />
                            <FormControl>
                                <FormLabel id="demo-controlled-radio-buttons-group">
                                    Matter Identifier Column
                                </FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedIdentifierOption}
                                    onChange={identifierSelectionHandler}
                                >
                                    {identifierOptions &&
                                        identifierOptions.map((opt) => {
                                            return (
                                                <FormControlLabel
                                                    value={opt.value}
                                                    control={<Radio />}
                                                    label={opt.label}
                                                />
                                            );
                                        })}
                                </RadioGroup>
                            </FormControl>
                        </Stack>
                    </DialogContent>
                </Dialog>
                <Stack direction="column" spacing={4} marginTop={4}>
                    <AppBar
                        sx={{ width: "100%", paddingY: 1, paddingX: 2 }}
                        buttonSpacing={6}
                        iconSpacing={6}
                    />
                    <DatabaseCard
                        statuses={statuses}
                        expand={expand}
                        setExpanded={setExpanded}
                        title={"View Import Logs"}
                    />
                    <Paper>
                        <MaterialTable
                            data={csvData ?? []}
                            columns={csvHeader ?? []}
                            title={"Import Your Matters with a .csv File"}
                        />
                    </Paper>
                    <Card sx={{ width: "100%", paddingX: 2, paddingY: 1 }}>
                        <Stack
                            direction={"row"}
                            spacing={2}
                            justifyContent="left"
                        >
                            <div
                                className="fileupload btn btn-primary waves-effect waves-light"
                                style={{ width: "12rem" }}
                            >
                                <input
                                    type="file"
                                    className="upload"
                                    onChange={handleFileChange}
                                    multiple
                                />
                                <span>Upload</span>
                            </div>
                            {csvData && csvHeader && identifierOptions && (
                                <button
                                    className="btn btn-primary waves-effect waves-light"
                                    style={{ width: "12rem" }}
                                    onClick={() => setShow(true)}
                                >
                                    <span>Choose Matter ID Column</span>
                                </button>
                            )}
                            {identifier && csvHeader && csvData && (
                                <button
                                    className="fileupload btn btn-success waves-effect waves-light"
                                    style={{ width: "12rem" }}
                                    onClick={() => setImporting(true)}
                                >
                                    <span>Import</span>
                                </button>
                            )}
                        </Stack>
                    </Card>
                </Stack>
            </div>
        </div>
    );
};

export default ImportPage;
